module.exports = __webpack_public_path__ + "img/template_story_3.7b830a04.png";